import { onMounted, ref, provide, reactive, toRefs, getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import PageLoading from '@/components/common/PageLoading.vue';
import Loading from '@/components/common/Loading.vue';
import Swiper from '@/components/layout/Swiper.vue';
import Header2 from '@/components/layout/header2.vue';
import Footer from '@/components/layout/footer.vue';
import Menu from '@/components/layout/menu.vue';
import bus from 'vue3-eventbus';
import SideComponent from '@/components/common/SideComponent.vue';
import { buildIntlCateUrl } from '@/utils/seoUrl.js';

export default {
	name: 'international_cates',
	components: {
		Header2,
		Menu,
		Swiper,
		Footer,
		PageLoading,
		SideComponent,
		Loading,
	},
	setup() {
		const { proxy } = getCurrentInstance();
		const router = useRouter();
		const route = useRoute();
		provide('logoColor', 'white');
		const data = reactive({
			isLoading: true,
			isPicLoading: true,
			showList: true,
			banners: [],
			cateList: [],
		});
		const showMenu = ref(proxy.$menus);
		provide('showMenu', showMenu);
		const store = useStore();
		const viewBox = ref(null);

		const scroll = (val) => {
			if (!viewBox.value) return;
			viewBox.value.scrollIntoView({
				behavior: 'smooth',
				block: val === 'top' ? 'start' : 'end',
				inline: 'center',
			});
		};

		const toCate = (id) => {
			router.push(buildIntlCateUrl(id));
		};

		const coverOf = async (cate) => {
			if (cate?.thumb) return cate.thumb;
			const res = await store.dispatch('common/InternationalList', {
				type: 2,
				cate_id: cate.id,
				page: 1,
				size: 1,
			});
			return res?.data?.[0]?.thumb || '';
		};

		onMounted(async () => {
			const legacyCateId = route.query.cate_id;
			if (legacyCateId) {
				router.replace(buildIntlCateUrl(legacyCateId));
				return;
			}
			try {
				const [site, cates] = await Promise.all([
					store.dispatch('common/fetchSiteInfo'),
					store.dispatch('common/InternationalCates'),
				]);
				data.banners = site?.international_sliders || [];
				const rows = Array.isArray(cates) ? cates : (cates?.data || []);
				data.cateList = await Promise.all(rows.map(async (cate) => ({
					...cate,
					thumb: await coverOf(cate),
				})));
			} catch (err) {
				data.cateList = [];
			}
			data.isPicLoading = false;
			data.isLoading = false;
			bus.emit('isLoading', false);
		});

		return {
			...toRefs(data),
			viewBox,
			scroll,
			toCate,
		};
	},
};
